export default {
  computed: {
    hasCollectFundsPermission() {
      return (
        this.isMerchantAdmin ||
        this.$role.verify([
          this.$role.COLLECT_FUNDS,
          this.$role.PARTIAL_COLLECT_FUNDS
        ])
      );
    },
    hasPartialCollectFundsPermissions() {
      return (
        this.isMerchantAdmin ||
        this.$role.verify([this.$role.PARTIAL_COLLECT_FUNDS])
      );
    },
    hasRefundTransactionsPermissions() {
      return (
        this.isMerchantAdmin ||
        this.$role.verify([this.$role.REFUND_TRANSACTIONS])
      );
    },
    hasSearchTransactionsPermissions() {
      return (
        this.isMerchantAdmin ||
        this.$role.verify([this.$role.SEARCH_TRANSACTIONS])
      );
    },
    hasExportTransactionsPermissions() {
      return (
        this.isMerchantAdmin ||
        this.$role.verify([this.$role.EXPORT_TRANSACTIONS])
      );
    },
    isMerchantAdmin() {
      return this.$role.verify([this.$role.MERCHANT_ADMIN]);
    },
    authenticated() {
      return this.$role.verify([
        this.$role.VIEW_TRANSACTIONS,
        this.$role.EXPORT_TRANSACTIONS,
        this.$role.SEARCH_TRANSACTIONS,
        this.$role.COLLECT_FUNDS,
        this.$role.PARTIAL_COLLECT_FUNDS,
        this.$role.MERCHANT_ADMIN
      ]);
    }
  }
};
